var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"product_warpper"},[_c('div',{staticClass:"na_productcat_banner"},[_c('img',{attrs:{"src":_vm.bannerImage}})]),_c('inProductCat',{attrs:{"column":2,"pageNum":2}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }